/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useEffect, useState } from "react";

import { API } from "src/classes/api";
import { BigBlock } from "src/components/DrilledView/BigBlock";
import { DrilledBlockData } from "src/components/DrilledView/drilled.interfaces";
import { SidePanel } from "src/components/DrilledView/SidePanel/SidePanel";
import { LoadingType, LoadingWrapper } from "src/components/Layout/LoadingWrapper";
import { LoadingStatus } from "src/lib/types";

interface Props {
  blockId: string;
}
export function DrilledBlock({ blockId }: Props) {
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.Idle);
  const [data, setData] = useState<DrilledBlockData | null>(null);

  useEffect(() => {
    API.blocks
      .getDrilled(blockId)
      .then((res) => {
        setData(res);
        setLoadingStatus(LoadingStatus.Succeeded);
      })
      .catch(() => setLoadingStatus(LoadingStatus.Failed));
  }, []);

  return (
    <LoadingWrapper status={loadingStatus} loadingType={LoadingType.Inline}>
      {data && (
        <>
          <BigBlock block={data.block} />
          <SidePanel block={data.block} likedBy={data.likedBy} owner={data.owner} plates={data.plates} />
        </>
      )}
    </LoadingWrapper>
  );
}
